import apiClient from './apiClient';

// -- TypeScript Interfaces (aligned with backend models/p9310.go JSON tags) --

export interface QueryParams {
  empFrom?: string;   // F910_01 start
  empTo?: string;     // F910_01 end
  dateFrom?: string;  // F910_02 start (YYYY-MM-DD)
  dateTo?: string;    // F910_02 end (YYYY-MM-DD)
  gradeFrom?: string; // F901_37 start
  gradeTo?: string;   // F901_37 end
}

export interface AttendanceRow {
  f910_01: string;      // employee code
  f910_02: string;      // attendance date
  f910_11: string;      // attendance status code
  f910_12: string;      // attendance type code
  f910_13: string;      // punch-in time
  f910_14: string;      // remark
  f910_15: string;      // shift code
  f910_27: number;      // normal work hours (minutes)
  f910_28: number;      // overtime hours
  f910_29: number;      // late minutes
  f910_30: number;      // early leave minutes
  f901_37: string;      // job grade (from F901)
  emp_name: string;     // employee name (from F901)
}

export interface QueryResponse {
  data: AttendanceRow[];
  count: number;
  message?: string;
}

// -- API Client --

export const p9310Api = {
  /** POST /api/p9310/query - Query attendance detail by filters */
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/p9310/query', params);
    return res.data;
  },

  /** GET /api/p9310/lookup/:type/:code - Lookup name by type & code */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/p9310/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
